import clsx from 'clsx';
import styles from './course.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faMagnifyingGlass, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import ParticipantsTable from '~/components/ParticipantsTable';
import data from './participants.json';
import { getAllTopicProblemsByClass, getParticipantsInClass } from '~/api/courses';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { getRole } from '~/api/auth';

const { default: CourseComponent } = require('~/components/Course');

const MainChild = () => {
    const [textOfSearch, setTextOfSearch] = useState('');
    const [participants, setParticipants] = useState([]);
    const { id } = useParams();
    const [params, setParams] = useSearchParams();
    const page = typeof params.get('page') === 'string' ? params.get('page') : '1';

    const [role, setRole] = useState('normal');
    const [classActive, setClassActive] = useState('');
    const [classes, setClasses] = useState({});
    const [keysOfClasses, setKeysOfClasses] = useState([]);

    const handleChangeSearchInput = (event) => {
        setTextOfSearch(event.target.value);
    };

    const handleSubmitSearch = () => {};

    const handleUpdateClass = (name) => {
        setClassActive(name);
    };

    useEffect(() => {
        (async () => {
            const fetchRole = await getRole();
            setRole(fetchRole.body.role);
        })();
    }, []);

    useEffect(() => {
        (async () => {
            const getParticipants = await getParticipantsInClass(id);
            if (getParticipants.code === 200) {
                console.log(getParticipants.body.participants);
                setParticipants(getParticipants.body.participants);
            }
        })();
        // setParticipants(data);
    }, [id]);

    useEffect(() => {
        (async () => {
            const getAllTopics = await getAllTopicProblemsByClass(id);
            console.log(getAllTopics.body);
            setClasses(getAllTopics.body.topic_problems);
            let lengthOfClasses = Object.keys(getAllTopics.body.topic_problems);
            setKeysOfClasses(lengthOfClasses);

            for (let i = 0; i < lengthOfClasses.length; i++) {
                if (getAllTopics.body.topic_problems[lengthOfClasses[i]]['class_id'] === parseInt(id)) {
                    setClassActive(getAllTopics.body.topic_problems[lengthOfClasses[i]]['class_name']);
                }
            }
        })();
    }, [id]);

    return (
        <div className={clsx(styles.participants)}>
            {role === 'teacher' && (
                <div className={clsx(styles.sortBar)}>
                    <div className={clsx(styles.sortBarOptions)}>
                        {keysOfClasses.map((keyOfClasses, index) => {
                            return (
                                <Link
                                    className={clsx(
                                        styles.sortBarOptionsItem,
                                        keyOfClasses === classActive ? styles.sortBarOptionsItemActive : '',
                                    )}
                                    to={`/courses/${classes[keyOfClasses].class_id}/participants/`}
                                    onClick={() => handleUpdateClass(keyOfClasses)}
                                >
                                    <div className={clsx(styles.sortBarOptionsItemIcon)}>
                                        <FontAwesomeIcon icon={faLayerGroup} />
                                    </div>
                                    <div className={clsx(styles.sortBarOptionsItemName)}>{keyOfClasses}</div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            )}
            <div className={clsx(styles.participantsContainer)}>
                <div className={clsx(styles.participantsSortBar)}>
                    <div className={clsx(styles.block, styles.blockMain)}>
                        <div className={clsx(styles.blockIcon)}>
                            <FontAwesomeIcon icon={faUserGroup} />
                        </div>
                        <div className={clsx(styles.blockTitle)}>Enrolled users</div>
                    </div>
                </div>
                <div className={clsx(styles.participantsTable)}>
                    <div className={clsx(styles.participantsHead)}>
                        <div className={clsx('col-5')}>Full Name</div>
                        <div className={clsx('col-2')}>ID number</div>
                        <div className={clsx('col-2')}>Roles</div>
                        <div className={clsx('col-3')}>Setting</div>
                    </div>
                    <div className={clsx(styles.participantsBody)}>
                        <ParticipantsTable page={page} participants={participants} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const Participants = () => {
    return <CourseComponent state="participants" mainChild={<MainChild />} />;
};

export default Participants;
